import { render, staticRenderFns } from "./RoleEdit.vue?vue&type=template&id=09ce6b0e&scoped=true"
import script from "./RoleEdit.vue?vue&type=script&lang=js"
export * from "./RoleEdit.vue?vue&type=script&lang=js"
import style0 from "./RoleEdit.vue?vue&type=style&index=0&id=09ce6b0e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ce6b0e",
  null
  
)

export default component.exports